export default "__VITE_ASSET__DZnSu2X6__"